import View from '@/base/views/view';

class MailView extends View {

    static table = 'mail';

    static options () {
        let obj = {
            fieldsDataReplace: {
                MailAttachments: { name: 'MailAttachments', editor: [], label: 'MailAttachments', label: 'Link a Adjuntos',
                    rowFields: [
                        { name: 'Name', label: 'Name', columns: 3},
                        { name: 'Key', label: 'Key', columns: 4},
                        { name: 'URL', label: 'URL', columns: 4},
                   ]
                },
                MessageBody: { name: 'MessageBody', label: 'Message', editor: 'text-area-html-style',  columns: 12, hideFromList: true},
            },
            extraFields: [
                { name: 'tab4', editor: 'component', component: 'MailActivity', label: 'Activity',
                       componentName: 'MailActivity', componentPath: 'components/tools', inline: true
                },
                { name: 'Attach', label: 'Attachments', editor: 'attach', columns: 12, hideFromList: true},
                { name: 'tab1', label: 'Plain Text',  editor: 'tab', hideFromList: true,
                    fields: [
                        { name: 'MessageBody', editor: 'text-area',  columns: 12, hideFromList: true, rows: 20, defValue: ''},
                    ]
                },
                { name: 'tab2', label: 'Preview',  editor: 'tab', hideFromList: true,
                    fields: [
                        { name: 'MessageBody', editor: 'html',  columns: 12},
                    ]
                },
                { name: 'tab3', label: 'Styles',  editor: 'tab', hideFromList: true,
                    fields: [
                        { name: 'Styles', editor: 'text-area',  columns: 12, hideFromList: true, rows: 20},
                    ]
                },

            ],
            serverSide: true,
            canCopy: true,
            title: 'Mails',
            actions: [
                {
                    label: 'Send',
                    method: 'saveMailAndSend',
                    id: 'sendMail'
                }
            ],
            beforeSave (self) {
                if (!self.MailFrom) {
                    self.addError('Falta configurar casill de correo');
                    return true;
                }
            }
        }
        return obj
    }

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        let id = _.find(res.fields, (r) => r.name == 'id');
        if (id) {
            id.hidden = false;
            id.hideFromList = false;
        }
        //let body = _.find(res.fields, (r) => r.name == 'MessageBody');
        //if (body) body.rows = 10;
        let mailAttachments = _.findIndex(res.fields, (r) => r.name == 'MailAttachments');
        if (mailAttachments != -1) {
            res.fields.splice(mailAttachments, 1);
        }
        return res;
    }

}

export default MailView;
